import { debounce } from 'lodash';
import api from './api';

const DEBOUNCE_MS = 400;

// Reports `{ score }` on success and `{ failed: true }` when the check couldn't run, so callers
// can tell "this password is weak" apart from "we don't know yet" — the latter must never read
// as acceptable, since the server enforces the same rule at submit and would reject it.
function checkPasswordStrength(password, callback) {
  api({
    method: 'post',
    url: '/password_strength',
    data: { candidate_password: password },
  }).then((response) => {
    const { score } = response.data;
    callback(score === null || score === undefined ? { failed: true } : { score });
  }).catch(() => {
    callback({ failed: true });
  });
}

export default debounce(checkPasswordStrength, DEBOUNCE_MS);
